import axios from 'axios';
import config from '../config.json';
import { decryptWithAEScbc, encryptWithAEScbc, getDecryptLocalStorage, getStorageWithMultiTabCheck, getIsConfigExist, isCacheEnabled, getStorageWithMultiTabCheckWithoutEncryption, removeStorageWithMultiTabCheck } from '../utils/global_functions';
import { API_FAILURE_MESSAGES, AXIOS, API_SOURCE, LOCAL_STORAGE_KEYS, IS_CACHE } from '../utils/global_variables';
import { store } from '../redux/store';
import { toastConfig } from '../redux/actions/toast';
import { Buffer } from 'buffer';
import CryptoJS from 'crypto-js';
import { createIndexedDBStorage } from './models/indexdDB';

// if (AUTOMATION_ENV === 'true') {
//     window.axios = axios;
// }

// Maaz A - For Enironment Settings - Start
if (getIsConfigExist()) {
    var baseURL = config.Wave.URL;
} else {
    baseURL = '';
}
// Maaz A - For Enironment Settings - End



let objApisToBeCached = {
    'getScripFromInstrumentAndExchange': 300000, //[option chain actions]
    'getScripbytokenandMktSegId': 300000,//[FutureFaireValue,OptionValue,Dashboard indices,Livepulse card,EventDetailsModal,Header,NewsContent,,OptionChainToaster,SipDetails,SipGridPopover,AddLegMultiScriptModal,Multileg,Spread,GlobalSearch,alerts,watchlist controller,watchlist actions]
    'getUPIDetails': 300000,//[AddFundsModal,funds actions,]
    'getBankAccList': 300000, //[fundsModal]
    'getDynamicProductTypes': 300000, //this is cdn we are not saving cdn
    'GetWorldIndicesData': 300000,
    'getAppWaveScannerDetails': 300000, //[screeners]
    'getIndexDetails': 300000,//[indices]
    'getExchangeLinks': 300000,// [called in app info on load]
    'getNonBusinessDay': 300000,
};



const apiCall = axios.create({
    baseURL: baseURL,
    timeout: AXIOS.TIMEOUT,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
});







// Function to format string query params into encrypted query params as required by service
const transformQueryParams = (reqConfig, index, encryptionkey) => {
    let queryParamsObj = {};
    let encrypted_data;
    // starts extracting query string after "?"
    let queryString = reqConfig.url.substring(index + 1);
    let queryStringArr = queryString.split("&");
    for (let i = 0; i < queryStringArr.length; i++) {
        let param = [];
        // Ajitesh: adding condition here because in case of multileg orders, order id sometimes including = symbol hence due to incorrect order ids only partial trade info is received from API
        if (queryStringArr[i].includes("order_ids") === false) {
            param = queryStringArr[i].split("=");
            queryParamsObj[param[0]] = param[1];
        }
        else {
            queryParamsObj[param[0]] = param[1];
        }
    }
    const paramsStringified = JSON.stringify(queryParamsObj);
    encrypted_data = encryptWithAEScbc(encryptionkey, paramsStringified);
    let var1 = Buffer.from(encrypted_data).toString("base64");
    reqConfig.url = reqConfig.url.substring(0, index);
    reqConfig.params = { "payload": var1 };
};

function getApiName(strUrl) {
    const match = strUrl?.match(/\/v1\/([^/?]+)/);
    return match ? match[1] : null;
}




const requestLocks = {};
// Ajitesh - API transform start
apiCall.interceptors.request.use(async function (reqConfig) {
    let cachedResponse;
    if (objApisToBeCached[getApiName(reqConfig?.url)] && isCacheEnabled()) {
        let key = localStorage.getItem(LOCAL_STORAGE_KEYS.SERVER_KEY);
        // Used CryptoJS hash function to generate 256 bit hash so id payload is same always the hash will be same
        const requestId = CryptoJS.SHA256(JSON.stringify(reqConfig?.data)).toString(CryptoJS.enc.Base64);
        if (key && objApisToBeCached[getApiName(reqConfig?.url)]) {
            /*
                in netwrok request headers we send X-Request-ID with hashed id so
                in response we get back the same X-Request-ID so we can identify this response
                is related to particular request
            */
            // reqConfig.headers['X-Request-ID'] = requestId; not used as extra header sin not beign accepted
            reqConfig.cachekey = requestId;
        }
        // we assign request id response we stored in indexdb to cacheResponse so we can avoid fruther network request
        cachedResponse = await createIndexedDBStorage().find(requestId);
    }


    try {
        if (reqConfig?.data?.hasOwnProperty('user_id') && (reqConfig?.data?.user_id === null || reqConfig?.data?.user_id == '' || reqConfig?.data?.user_id === undefined)) {
            reqConfig.data.user_id = getStorageWithMultiTabCheckWithoutEncryption('ACTIVE_USER');
        }

        if (localStorage.getItem(LOCAL_STORAGE_KEYS.GUEST_USER) !== null && !reqConfig.guestAllowed && !reqConfig?.data?.guestAllowed) {
            return Promise.reject({ message: 'request already in progress' });
        }


        let { data } = reqConfig;
        let encryptionkey;


        if (reqConfig?.lock || reqConfig?.data?.lock) {
            const requestKeys = `${reqConfig.method}:${reqConfig.url}`;
            if (requestLocks[requestKeys]) {
                return Promise.reject({ message: 'request already in progress' });
            } else {
                requestLocks[requestKeys] = true;
            }
        }



        if (!reqConfig.url.includes('uploadProfilePicture') && localStorage.getItem(LOCAL_STORAGE_KEYS.HEADER) !== null && !reqConfig.url.includes('cds') && localStorage.getItem(LOCAL_STORAGE_KEYS.SERVER_KEY) !== null) {
            let additionalHeader = localStorage.getItem(LOCAL_STORAGE_KEYS.HEADER);
            reqConfig.headers['x-bts-enc'] = additionalHeader;

            encryptionkey = localStorage.getItem(LOCAL_STORAGE_KEYS.SERVER_KEY);
        }
        if (reqConfig.url.includes('uploadProfilePicture')) {
            let additionalHeader = localStorage.getItem(LOCAL_STORAGE_KEYS.HEADER);
            reqConfig.headers['x-bts-enc'] = additionalHeader;
            reqConfig.headers = {
                ...reqConfig.headers,
                "Content-Type": undefined,
            };
        }


        if (reqConfig.isAllowedDeviceInfo) {
            reqConfig.data = { ...data, deviceinfo: JSON.parse(getDecryptLocalStorage(LOCAL_STORAGE_KEYS.DEVICE_INFO)) };
        }
        if (reqConfig.url.indexOf("?") > -1 && encryptionkey) {
            let index = reqConfig.url.indexOf("?");
            transformQueryParams(reqConfig, index, encryptionkey);
        } else if (encryptionkey && !reqConfig.url.includes('cds') && reqConfig?.data && !reqConfig.url.includes('uploadProfilePicture')) {
            let stringifiedPayload = JSON.stringify(reqConfig.data);

            reqConfig.data = { payload: encryptWithAEScbc(encryptionkey, stringifiedPayload) };
        }

        // Ajitesh 16/05-2024 Check for auth token
        let objLoginSession = getStorageWithMultiTabCheck(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION);
        // For APIs that are made pre login and have request data add source and api key
        if (reqConfig.data && !reqConfig.headers.authorization && !objLoginSession?.data?.access_token) {
            reqConfig.data.source = API_SOURCE.BREEZE;
            reqConfig.data.api_key = config.Wave.ApiKey;
        }


        if (objLoginSession) {
            objLoginSession = JSON.parse(objLoginSession);
            if (reqConfig.url.indexOf("getAppSyncDetailsByTenant") === -1 && objLoginSession?.data?.access_token) {
                reqConfig.headers.authorization = `Bearer ${objLoginSession?.data?.access_token}`;
            }
        }
        /*
            Bottom code is responsible for validating to return cached response
            as response is encrypted we decrypt and send back decrypted cached response
        */
        if (cachedResponse && objApisToBeCached[getApiName(reqConfig?.url)] && isCacheEnabled()) {
            let convertedResponse = JSON.parse(cachedResponse);
            if (Date.now() - convertedResponse?.timeStamp < convertedResponse?.ttl) { // validating tll with current time stamp and timestamp of stored response
                if (localStorage.getItem(LOCAL_STORAGE_KEYS.SERVER_KEY) !== null) {
                    let encryptionKey = localStorage.getItem(LOCAL_STORAGE_KEYS.SERVER_KEY);
                    let decryptResponse;
                    if (convertedResponse?.data?.payload) {
                        decryptResponse = decryptWithAEScbc(encryptionKey, convertedResponse?.data?.payload);
                        convertedResponse.data = JSON.parse(decryptResponse);
                    }
                }
                /*
                 as axios take only reject or request configuration of network call
                 we reject with cache as true so this reject will be cached my error of response interceptor
                 there in response interceptor we resolve the response
                */
                return new Promise((resolve, reject) => {
                    reject({ ...convertedResponse, cache: true });
                });
            } else {
                return reqConfig;
            }

        } else {

            return reqConfig;
        }

    } catch (error) {
        console.error(error);
        return reqConfig;
    }
}, function (error) {
    console.error(error);
    return Promise.reject(error);
});


apiCall.interceptors.response.use(function (response) {
    const requestKeys = `${response?.config?.method}:${response?.config?.url}`;

    delete requestLocks[requestKeys];

    let encryptionKey;
    /*
    if cache is enabled abd X-request-ID is present we send then we store with extra attributes timestamp and tll
    we store in indexdb
    */
    //Azeem :21:0-03-2025 : IS_CACHE was not imported(undefined) getting error, imported IS_CACHE from global_variables.js
    if (response.config.cachekey && objApisToBeCached[getApiName(response.config?.url)] && IS_CACHE) {
        const requestId = response.config.cachekey;
        createIndexedDBStorage().set(requestId, JSON.stringify({ ...response, cache: true, timeStamp: Date.now(), ttl: objApisToBeCached[getApiName(response.config?.url)] }));
    }
    if (!response?.config?.url.includes('cds')) {
        if (localStorage.getItem(LOCAL_STORAGE_KEYS.SERVER_KEY) !== null) {
            encryptionKey = localStorage.getItem(LOCAL_STORAGE_KEYS.SERVER_KEY);
            let decryptResponse;
            if (response?.data?.payload) {
                decryptResponse = decryptWithAEScbc(encryptionKey, response?.data?.payload);
                response.data = JSON.parse(decryptResponse);

            }
        }
    }


    return response;

}, function (error) {
    if (error.cache) {
        return Promise.resolve(error);
    } else {


        const requestKeys = `${error?.config?.method}:${error?.config?.url}`;

        delete requestLocks[requestKeys];


        if (localStorage.getItem(LOCAL_STORAGE_KEYS.SERVER_KEY) !== null) {
            let encryptionKey = localStorage.getItem(LOCAL_STORAGE_KEYS.SERVER_KEY);
            let decryptedResponse = decryptWithAEScbc(encryptionKey, error?.response?.data?.payload);
            let parsedResponse = JSON.parse(decryptedResponse);
            error.response.data = parsedResponse;
        }
        if (error?.response?.data?.errors?.name === 'TokenExpiredError' ||
            //Azeem K :27-04-2024:logged out user if session is expired --Start
            error?.response?.data?.message?.toUpperCase()?.trim()?.includes(API_FAILURE_MESSAGES.INVALID_SESSION) ||
            error?.response?.data?.message?.toUpperCase()?.trim()?.includes(API_FAILURE_MESSAGES.SESSION_DATA_NOT_RECEIVED) ||
            error?.response?.data?.message?.toUpperCase()?.trim()?.includes(API_FAILURE_MESSAGES.SESSION_ID_NOT_AVAILABLE) ||
            error?.response?.data?.message?.toUpperCase()?.trim()?.includes(API_FAILURE_MESSAGES.USER_NOT_AUTHORIZED)) {
            removeStorageWithMultiTabCheck(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION);
            removeStorageWithMultiTabCheck(LOCAL_STORAGE_KEYS.CHART_URL_ATTRIBUTES);
            window.location.replace('/');
            //Azeem K :27-04-2024:logged out user if session is expired --Start
            store.dispatch(toastConfig({
                show: true, message: "Session Expired!", backdrop: true, button: [
                    {
                        btnName: "Ok", className: "btn btn-solid ms-3 ", onClickHandler: () => {
                            localStorage.removeItem(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION);
                            localStorage.removeItem(LOCAL_STORAGE_KEYS.CHART_URL_ATTRIBUTES);
                            window.location.replace('/');
                            store.dispatch(toastConfig({ show: false }));
                        }
                    }]
            }));
            //Azeem K :27-04-2024:logged out user if session is expired --End
            //Azeem K :27-04-2024:logged out user if session is expired --End
        } else { }
        return Promise.reject(error);
    }
});
// Ajitesh API transform end

//export { apiCallEncrypted };
export default apiCall;